import { render } from "./PageControl.vue?vue&type=template&id=c9eaa9a0"
import script from "./PageControl.vue?vue&type=script&lang=js"
export * from "./PageControl.vue?vue&type=script&lang=js"

import "./PageControl.vue?vue&type=style&index=0&id=c9eaa9a0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__